import 'css/app.scss';

import CommunityPage from './containers/CommunityPage';

export default (): React.ReactNode => CommunityPage;
